import {
  AbstractEntityTabLoader
} from '../../../utils/component/abstract-entity-tab-loader/abstract-entity-tab.loader';
import { ExplanationContentEntity } from '../explanation-content-entity';

export class ExplanationContentTabLoader
  extends AbstractEntityTabLoader<ExplanationContentEntity> {
  protected pageSize = 20;
  protected sort = 'name';
  protected searchFilterKey = 'filter[nameLike]';
}
